<nav [ngClass]="{ navCollapsed: hideNavigator }">
  <netfoundry-ui-ziti-assets [isCloudZiti]="isCloudZiti"></netfoundry-ui-ziti-assets>
  @if (!hide || hideNavigator) {
    <app-side-navigator (mouseenter)="removeClose()" [disableNavigation]="disableNavigation" [(showExpandCollapseIcon)]="showExpandCollapseIcon"></app-side-navigator>
  }
</nav>
